import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './modal.style.css';
import IntlMessage from '../../helpers/intlMessage';

function ModalComponent(props) {
	const [modal, setModal] = useState(false);

	useEffect(() => {
		setModal(props.visivel);
	}, [props.visivel]);

	const toggle = () => {
		setModal(!modal);
	};

	const cancela = () => {
		props.cancela();
		toggle();
	};

	const confirma = () => {
		props.confirma();
		toggle();
	};

	const novo = () => {
		props.novo();
		toggle();
	};

	return (
		<div>
			<Modal
				size={props.size}
				isOpen={modal}
				toggle={cancela}
				style={props.style}
			>
				<ModalHeader toggle={cancela}>{props.titulo}</ModalHeader>
				{props.noFooter ? (
					props.children
				) : (
					<ModalBody>{props.children}</ModalBody>
				)}

				{!props.noFooter && (
					<ModalFooter>
						{typeof props.novo === 'function' ? (
							<Button className="btn-novo" color="primary" onClick={novo}>
								<IntlMessage id = "dashboards.examDetails.new"/>
							</Button>
						) : undefined}
						<Button
							className="modalComponente-fechar"
							color="secondary"
							onClick={cancela}
							tabIndex="-1"
						>
							<IntlMessage id = "dashboards.examDetail.close"/>
						</Button>
						{typeof props.confirma === 'function' ? (
							<Button
								disabled={props.disabled}
								color="primary"
								onClick={confirma}
							>
								<IntlMessage id = "dashboards.examDetails.confirm"/>
							</Button>
						) : undefined}
					</ModalFooter>
				)}
			</Modal>
		</div>
	);
}

ModalComponent.propTypes = {
	children: PropTypes.node,
	titulo: PropTypes.string,
	confirma: PropTypes.func,
	cancela: PropTypes.func,
	novo: PropTypes.func,
	visivel: PropTypes.bool,
	size: PropTypes.string,
};

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/componentes/modal/modal.component.jsx